import React from "react";
import TkProgressBar from "@xo-union/tk-component-progress-bar";
import PropTypes from "prop-types";
var ProgressBar = function ProgressBar(_ref) {
  var maxStep = _ref.maxStep,
    currentStep = _ref.currentStep;
  return /*#__PURE__*/React.createElement(TkProgressBar, {
    value: currentStep,
    max: maxStep
  });
};
export default ProgressBar;
process.env.NODE_ENV !== "production" ? ProgressBar.propTypes = {
  maxStep: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired
} : void 0;